// Add tracking events for GA, Active Campaign etc
export function trackEvents(){
  // ...
}


// WEBPACK FOOTER //
// ./scripts/insight.js